import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const EntitlementAlert = lazy(() => import('./EntitlementAlert'))

class EntitlementAlertWebComponent extends ReactWebComponent {
  static get observedAttributes() {
    return ['alert-props', 'alert-type', 'team-uuid']
  }

  override render() {
    const rawAlertType = this.prop('alert-type')
    const rawAlertProps = this.prop('alert-props')
    const teamUuid = this.prop('team-uuid')

    return (
      <RootProviders>
        <EntitlementAlert alertType={rawAlertType} alertProps={rawAlertProps} teamUuid={teamUuid} />
      </RootProviders>
    )
  }
}

customElements.define('entitlement-alert', EntitlementAlertWebComponent)
